export default __webpack_public_path__ + "static/media/object--mailbox.6bae4b92.png";